  //
  // ボタンをクリックしたらスクロールして上に戻る
  //
function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

// 
// アコーディオン
// 
document.querySelectorAll('.js-accordionWrap').forEach(accordion => {
  const toggleBtn = accordion.querySelector('.accordion-btn');
  const closeBtn = accordion.querySelector('.accordion-close');
  const content = accordion.querySelector('.accordion');

  // アニメーション後、autoに切り替える（動的対応のため）
  content.addEventListener('transitionend', () => {
    if (accordion.classList.contains('_isOpen')) {
      content.style.height = 'auto'; // ←ここがキモ
    }
  });

  const openAccordion = () => {
    // 1. 一度 height を auto にして、scrollHeight を正確に取得
    content.style.height = 'auto';
    const height = content.scrollHeight + 'px';

    // 2. 一度リセットしてからアニメーション用に数値を代入
    content.style.height = '0px'; // ← これがないと transition 効かない
    requestAnimationFrame(() => {
      content.style.height = height;
    });

    accordion.classList.add('_isOpen');
  };

  const closeAccordion = () => {
    // 1. 固定値にしてアニメーション
    content.style.height = content.scrollHeight + 'px';

    // 2. 直後に 0 に戻す
    requestAnimationFrame(() => {
      content.style.height = '0px';
      accordion.classList.remove('_isOpen');

      // アコーディオンが閉じた後に、#accordion にスクロール
      const accordionElement = document.getElementById('accordion');
      if (accordionElement) {
        accordionElement.scrollIntoView({ behavior: 'smooth' });
      }
    });
  };

  toggleBtn.addEventListener('click', e => {
    e.preventDefault();
    if (accordion.classList.contains('_isOpen')) {
      closeAccordion();
    } else {
      openAccordion();
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', e => {
      e.preventDefault();
      closeAccordion();
    });
  }

  // 初期化
  content.style.height = '0';
});


// 
// 要素の中央点が30%〜70%範囲に入っている間だけ
// 

document.addEventListener('DOMContentLoaded', () => {
  const actionElements = document.querySelectorAll('.js-action');

    // ===== 初回のみ：HTMLに書かれた _isActive を外す =====
  actionElements.forEach(el => {
    if (el.classList.contains('_isActive')) {
      el.classList.remove('_isActive');
    }
  });
  // ================================================

  function isInMiddleViewport(el) {
    const rect = el.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // 画面の30%〜70%ゾーン
    const upperBound = windowHeight * 0.0;
    const lowerBound = windowHeight * 0.7;

    // 要素の中心位置
    const elementCenterY = rect.top + rect.height / 2;

    return (
      elementCenterY >= upperBound &&
      elementCenterY <= lowerBound
    );
  }

  let ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        actionElements.forEach(el => {
          if (isInMiddleViewport(el)) {
            el.classList.add('_isActive'); // ← 付けたいクラス
          } else {
            el.classList.remove('_isActive');
          }
        });
        ticking = false;
      });
      ticking = true;
    }
  }

  // 初期状態
  actionElements.forEach(el => {
    el.classList.remove('_isActive');
  });

  window.addEventListener('scroll', onScroll);
  window.addEventListener('resize', onScroll);
  onScroll(); // 初回判定
});

// 
// ヘッダーが白いところに重なったら、ロゴを黒くする
// 
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  const targets = document.querySelectorAll('.cta, .bg-tertiary');

  if (!header || targets.length === 0) return;

  const updateHeaderColor = () => {
    const headerHeight = header.offsetHeight;
    const triggerLine = headerHeight / 2;

    let isOverlapping = false;

    targets.forEach(target => {
      const rect = target.getBoundingClientRect();

      // triggerLine が target の上下範囲に入っているか
      if (rect.top <= triggerLine && rect.bottom >= triggerLine) {
        isOverlapping = true;
      }
    });

    header.classList.toggle('_black', isOverlapping);
  };

  // 初期実行
  updateHeaderColor();

  // スクロール・リサイズで監視
  window.addEventListener('scroll', updateHeaderColor);
  window.addEventListener('resize', updateHeaderColor);
});
